/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /app-monorepo-projects/packages/app-share/src/services/fetch-feed-detail/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { formatFeed } from '@/utils/formatter';
import { H5_CALL_PATH } from '@/constants/url';
import { DEFAULT_ERR_MSG } from '@/constants/index';
import { ModelMetaFeed } from '@/types/model';
import { FetchFeedDetailReq, FetchFeedDetailRsp } from '@/types/services/fetch-feed-detail';

type FetchResult = {
  errMsg?: string,
  feeds: ModelMetaFeed[],
};

/**
 *
 * 获取feed详情
 * @export
 * @param
 * @return {*}  {(Promise<FetchRsp>)}
 */
export default async function fetchFeedDetail(params: FetchFeedDetailReq): Promise<FetchResult> {
  const fetchConfig: AjaxConfig = {
    url: `${H5_CALL_PATH}/weishi/WSH5GetPlayPage`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    data: JSON.stringify({
      feedid: params.feedid,
      // 是否需要推荐数据，0:不需要推荐数据；1:只需要推荐数据；2:Feed本身和推荐数据都要
      recommendtype: params.dataType !== undefined ? params.dataType : 2,
      datalvl: 'all',
      _weishi_mapExt: {
        traceid: params.traceid,
        need264: '1',
      },
    }),
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return { errMsg: DEFAULT_ERR_MSG, feeds: [] };
  try {
    const { request } = wslAjax;
    const res = await request<FetchFeedDetailRsp>(fetchConfig);
    const data = res?.data;
    if (data?.feeds?.length) {
      return {
        feeds: data.feeds.map((feed, index) => formatFeed(feed, index)),
        errMsg: '',
      };
    }
    return {
      feeds: [],
      errMsg: data?.errmsg ?? res?.msg,
    };
  } catch (err) {
    console.error('接口fetchFeedDetail出现了一些问题');
  }
  return { errMsg: DEFAULT_ERR_MSG, feeds: [] };
}
